import { signal } from "@preact/signals-react";

const userInfoSignal = new signal({
  sumTransaction: 0
});

export { userInfoSignal };
